export const TAP_TOOLS_PS = "TAP Tools PS";
export const TAP_TOOLS_SUPPORT = "TAP Tools Support";
export const TAP_TOOLS_SUPER = "TAP Tools Super";
export const TAP_TOOLS_TIER_1 = "TAP Tools Tier 1";
export const TAP_TOOLS_THOR = "TAP Tools Thor";
export const TAP_TOOLS_FRAUD_SUPPORT = "TAP Tools Fraud Support";
export const TAP_TOOLS_DIAL_PLAN_ADMIN = "TAP Tools Dialplan Admin";
export const TAP_TOOLS_CANCELATION = "TAP Tools Cancelation";
export const TAP_ALL = [
  TAP_TOOLS_PS,
  TAP_TOOLS_SUPPORT,
  TAP_TOOLS_SUPER,
  TAP_TOOLS_TIER_1,
  TAP_TOOLS_THOR,
  TAP_TOOLS_FRAUD_SUPPORT,
  TAP_TOOLS_DIAL_PLAN_ADMIN,
  TAP_TOOLS_CANCELATION,
];

export const TAP_HOME_LINKS = [
  TAP_TOOLS_SUPER,
  TAP_TOOLS_PS,
  TAP_TOOLS_THOR,
  TAP_TOOLS_SUPPORT,
  TAP_TOOLS_TIER_1,
];
